import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { BusinessOpeningHours } from '@/models/businesses/business-opening-hours';
import { ContactDetails } from '@/models/common/contact-details';
import { axiosService } from '.';

export default class BusinessFrontPagesService {
    public async getBusinessFrontPage(businessId: number): Promise<BusinessFrontPage> {
        const businessFrontPageData = (await axiosService.instance.get(`businesses/organization/front-page/${businessId}`)).data;
        return new BusinessFrontPage(businessFrontPageData ? businessFrontPageData : { businessId });
    }

    public async updateBusinessFrontPageDescription(businessId: number, description: string): Promise<boolean> {
        const Entities = require('html-entities').AllHtmlEntities;
        const entities = new Entities();

        return (await axiosService.instance.post(`businesses/organization/front-page/${businessId}/update-description`, { description: entities.encode(description) })).data;
    }

    public async updateBusinessFrontPageContactDetails(businessId: number, contactDetails: ContactDetails): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/front-page/${businessId}/update-contact-details`, contactDetails)).data;
    }

    public async checkIfBusinessFrontPageSlugExists(businessId: number, slug: string): Promise<boolean> {
        return (await axiosService.instance.get(`businesses/organization/front-page/${businessId}/check-if-slug-exists?slug=${slug}`)).data;
    }

    public async updateBusinessFrontPageSlug(businessId: number, slug: string): Promise<boolean> {
        if (!slug) {
            slug = '';
        }

        return (await axiosService.instance.post(`businesses/organization/front-page/${businessId}/update-slug?slug=${slug}`)).data;
    }

    public async publishBusinessFrontPage(businessId: number): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/front-page/${businessId}/publish`)).data;
    }

    public async isPublishedBusinessFrontPage(businessId: number, checkBusinessFrontPageSlugExists: boolean): Promise<boolean> {
        return (await axiosService.instance.get(`businesses/organization/front-page/${businessId}/is-published?checkBusinessFrontPageSlugExists=${checkBusinessFrontPageSlugExists}`)).data;
    }

    public async updateBusinessFrontPageOpeningHours(businessId: number, openingHours: BusinessOpeningHours): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/front-page/${businessId}/opening-hours`, openingHours)).data;
    }
}

export const businessFrontPagesService = new BusinessFrontPagesService();
